import React, { Component } from "react";

import { defined } from "@formant/core/common/defined";
import { IDevice } from "@formant/core/model/IDevice";
import { Uuid } from "@formant/core/model/Uuid";

import { DeviceCheck } from "./DeviceCheck";

export interface IRowCheckProps {
    device: IDevice;
    checked: boolean;
    visible: boolean;
    className?: string;
    onToggle: (id: Uuid) => void;
}

export class RowCheck extends Component<IRowCheckProps> {
    public render() {
        const { checked, visible, className } = this.props;

        return (
            <DeviceCheck
                checked={checked}
                visible={visible}
                className={className}
                onToggle={this.onToggle}
            />
        );
    }

    private onToggle = () => {
        const { device, onToggle } = this.props;
        const id = defined(device.id);
        onToggle(id);
    };
}
